/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import { errorResponseExtraDataSchema } from "./errorResponseExtraDataSchema.ts";

export const errorResponseExtraSchema = z.object({
	action: z.string().nullable(),
	data: errorResponseExtraDataSchema,
});
